import * as React from 'react'
import styled, { css } from 'styled-components'

import Icon from '../Icon'
import Text from 'components/Text'

const StepperProgress: React.FC<{
  stepTitles: string[]
  currentStep: number
}> = ({ stepTitles, currentStep }) => {
  const progressPerStep = 100 / (stepTitles.length - 1)
  const progress = (currentStep - 1) * progressPerStep
  return (
    <Progress className="stepper-progress">
      <ProgressWrapper className="stepper-progress-wrapper">
        <PreProgressBar className="stepper-progress-bar" style={{ width: '100%' }} />
        <ProgressBar className="stepper-progress-bar" style={{ width: progress + '%' }} />
        {stepTitles.map((title, i) => {
          const visited = i + 1 < currentStep
          const current = i + 1 === currentStep
          return (
            <StepTitle key={i} className="step-title">
              <StepTitleNumber className="step-title-number" visited={visited} current={current}>
                {visited && <Icon icon={['fa', 'check']} color="blue1" fontSize={14} />}
                {!visited && <>{i + 1}</>}
              </StepTitleNumber>
              <Text>{title}</Text>
            </StepTitle>
          )
        })}
      </ProgressWrapper>
    </Progress>
  )
}

export default StepperProgress

const Progress = styled.div`
  position: relative;
  width: 100%;
  z-index: 9;
`
const ProgressWrapper = styled.div`
  width: 90%;
  position: relative;
  display: flex;
  margin: auto;
  justify-content: space-between;
`

const ProgressBar = styled.div`
  position: absolute;
  width: 100%;
  height: 3px;
  top: 13px;
  z-index: -1;
  border-top: 2px ${({ theme }) => theme.colors.gray7};
  border-style: dashed;
`
const PreProgressBar = styled.div`
  position: absolute;
  width: 100%;
  height: 3px;
  top: 13px;
  z-index: -1;
  border-top: 2px solid ${({ theme }) => theme.colors.gray4};
  border-style: dashed;
`

const StepTitle = styled.div`
  display: flex;
  text-align: center;
  font-size: 0.9rem;
  align-items: center;
  background: #fff;
  padding: 0 1rem;
  height: 30px;
`
const visitedTitleNumber = css`
  color: ${({ theme }) => theme.colors.gray7};
  border: 1px solid ${({ theme }) => theme.colors.blue1};
`
const futureTitleNumber = css`
  color: ${({ theme }) => theme.colors.gray5};
  background: ${({ theme }) => theme.colors.gray11};
`

const currentTitleNumber = css`
  color: ${({ theme }) => theme.colors.blue1};
  border: 1px solid ${({ theme }) => theme.colors.blue1};
`
const StepTitleNumber = styled.div<{ visited: boolean; current: boolean }>`
  font-size: 1rem;
  background: ${({ theme }) => theme.colors.gray11};
  height: 24px;
  width: 24px;
  margin: 0.3rem 0.3rem;
  line-height: 1.5;
  border-radius: 100%;
  ${({ visited }) => (visited ? visitedTitleNumber : futureTitleNumber)}
  ${({ current }) => (current ? currentTitleNumber : futureTitleNumber)}
`
